import { render, staticRenderFns } from "./GlyphShowcasePanelEntry.vue?vue&type=template&id=3566024d&scoped=true"
import script from "./GlyphShowcasePanelEntry.vue?vue&type=script&lang=js"
export * from "./GlyphShowcasePanelEntry.vue?vue&type=script&lang=js"
import style0 from "./GlyphShowcasePanelEntry.vue?vue&type=style&index=0&id=3566024d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3566024d",
  null
  
)

export default component.exports